import { ModalBackground, ModalCard } from "../../dashboard/hometab/styles";
import SubmitButton from "../../atoms/submitbutton";
import { useState } from "react";
import { Heading, Input } from "./styles";
import { useSelector } from "react-redux";
import * as yup from "yup";
import { toast } from "react-toastify";
import axios from "axios";
import { API_URL } from "../../../constants";
import { useForm } from "react-hook-form";
import { accountSchema } from "../../../validations/account";
import { yupResolver } from "@hookform/resolvers/yup";

type FormData = yup.InferType<typeof accountSchema>;

interface PaymentProps {
  toggleClear: () => void;
  account: any;
  refresh: boolean;
  setRefresh: any;
}
export function PaymentModal({ toggleClear, account, refresh, setRefresh }: PaymentProps) {
  const [isloading, setisloading] = useState(false);
  let businessUuid = useSelector((state: any) => state.auth.uuid);

  const { register, handleSubmit, formState, reset } = useForm<FormData>({
    resolver: yupResolver(accountSchema),
    defaultValues: {
      bankName: account?.BankName,
      accountNumber: account?.accountNumber,
      accountName: account?.accountName,
    },
  });
  const { errors } = formState;

  const createRequest = (data: any) => {
    setisloading(true);

    let formData: any = {
      businessUuid: businessUuid,
      bankName: data.bankName,
      accountNumber: data.accountNumber,
      accountName: data.accountName,
    };
    axios
      .post(`${API_URL}/bank_account_details/update`, formData)
      .then((response) => {
        if (response.status === 200 || response.status === 201) {
          setisloading(false);
          toast.success(response.data.message);
          reset();
          toggleClear();
          setRefresh(!refresh);
        }
      })
      .catch((error) => {
        setisloading(false);

        if (error?.response?.status === 400 || error?.response?.status === 401) {
          toast.error(error?.response?.data?.message);
          return;
        }
        toast.error("Connection Failed");
      });
  };

  return (
    <ModalBackground onClick={toggleClear}>
      <ModalCard onClick={(event) => event.stopPropagation()}>
        <div>
          <Heading>Payout Information</Heading>

          <form onSubmit={handleSubmit(createRequest)}>
            <Input type="text" placeholder="Account Number" {...register("accountNumber")} />
            {errors?.accountNumber && <p className="text-xs mb-2 text-red-600">{errors.accountNumber?.message}</p>}
            <Input type="text" placeholder="Bank Name" {...register("bankName")} />
            {errors?.bankName && <p className="text-xs mb-2 text-red-600">{errors.bankName?.message}</p>}
            <Input type="text" placeholder="Account Name" {...register("accountName")} />
            {errors?.accountName && <p className="text-xs mb-2 text-red-600">{errors.accountName?.message}</p>}
            <SubmitButton isloading={isloading} value="Save" width="19.6em" />
          </form>
        </div>
      </ModalCard>
    </ModalBackground>
  );
}
